import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { Road, ArrowRight } from "lucide-react"
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "./CommonComponents/Loader";

const Tracking = () => {
    const inputrefs = useRef([]);
    const [trackingData, setTrackingData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [podImage, setPodImage] = useState("");
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const awbNoFromURL = params.get("awbNo");
    const refNoFromURL = params.get("refNo");
    const [trackValue, setTrackValue] = useState("");
    const [hasSearched, setHasSearched] = useState(false);
    const [loading, setLoading] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [trackType, setTrackType] = useState("awb");

    const fetchTracking = async (type, value) => {
        try {
            setLoading(true);
            const payload = {
                AuthToken: "NASSKD28462RWKF35793FWEU757",
                Source: "Web",
                type: type === "awb" ? "AwbNo" : "RefNo",
                awbNo: value
            };
            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/api/Tracking/TrackingAwb`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            const data = await res.json();
            if (data.status === "SUCCESS") {
                setTrackingData(data?.awbTracking || []);
                setHasSearched(true);
                // toast.success("Tracking data fetched successfully");
            } else {
                setTrackingData([]);
                setHasSearched(true);
                toast.error(data.message || "Tracking not found ");
            }
            setLoading(false);
        } catch (err) {
            console.error("API Error:", err);
        }
    };


    const fetchPOD = async (awbNo) => {
        setBtnLoading(true);
        try {

            const payload = {
                AuthToken: "NASSKD28462RWKF35793FWEU757",
                Source: "Web",
                awbNo: awbNo,
                Type: trackType === "awb" ? "AwbNo" : "RefNo",
            };

            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/Tracking/TrackingAwbPOD`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const data = await res.json();

            if (data.status === "SUCCESS") {
                setPodImage(data?.podBase64);
                setShowModal(true);
            } else {
                toast.error("POD not found");
            }
        } catch (err) {
            console.error(err);
        } finally {
            setBtnLoading(false);
        }
    };

    const status = trackingData?.packetStatus;

    let statusClass = "blue";

    if (status?.toLowerCase() === "delivered") {
        statusClass = "green";
    } else if (status?.toLowerCase() === "in transit") {
        statusClass = "blue";
    } else if (status?.toLowerCase() === "out for delivery") {
        statusClass = "orange";
    } else if (status?.toLowerCase() === "booked") {
        statusClass = "yellow";
    }

    useEffect(() => {
        if (awbNoFromURL) {
            setTrackValue(awbNoFromURL);
            setTrackType("awb");
            fetchTracking("awb", awbNoFromURL);
        } else if (refNoFromURL) {
            setTrackValue(refNoFromURL);
            setTrackType("ref");
            fetchTracking("ref", refNoFromURL);
        } else {
            setTrackingData([]);
            setTrackValue("");
            setHasSearched(false);
        }
    }, [awbNoFromURL, refNoFromURL]);

    const handleDownloadPOD = () => {
        if (!podImage) return;

        const link = document.createElement("a");
        link.href = `data:image/jpeg;base64,${podImage}`;
        link.download = `POD_${Date.now()}.jpg`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleSearch = () => {

        setTrackingData([]);
        setHasSearched(false);

        if (trackType === "awb") {
            fetchTracking("awb", trackValue);
        } else {
            fetchTracking("ref", trackValue);
        }
    };

    const startOffset = 12.5;

    return (
        <>
{loading ? (
                <Loader />
            ) : (
                <section className="tracking_wrap">
                    <div className="container">
                        {!trackingData?.awbNo && (
                            <>
                                <h1 className="text-center fw-bold text-dark mt-5">
                                    Track Your Shipment
                                </h1>

                                <p className="text-center text-secondary mt-4">
                                    Enter your consignment or reference number to track your package
                                </p>

                                <p className="text-center text-muted small mt-2">
                                    and view detailed shipment progress.
                                </p>
                            </>
                        )}
                        <div className="track-label text-center">For multiple tracking, use Enter key</div>

                        <div className="track-radio d-flex justify-content-center gap-4">
                                <label className="d-flex align-items-center gap-2">
                                    <input
                                        type="radio"
                                        name="ttype"
                                        checked={trackType === "awb"}
                                        onChange={() => {
                                            setTrackType("awb");
                                            setTrackingData([]);
                                            setHasSearched(false);
                                            setTrackValue("");
                                        }}
                                    />
                                    <span>AWB No.</span>
                                </label>

                                <label className="d-flex align-items-center gap-2">
                                    <input
                                        type="radio"
                                        name="ttype"
                                        checked={trackType === "ref"}
                                        onChange={() => {
                                            setTrackType("ref");
                                            setTrackingData([]);
                                            setHasSearched(false);
                                            setTrackValue("");
                                        }}
                                    />
                                    <span>Ref No.</span>
                                </label>
                        </div>
                        {/* SEARCH */}
                        <div className="search-wrap mt-5">
                            <i className="fa fa-search s-icon"></i>
                            <input
                                type="text"
                                id="trackInput"
                                    value={trackValue}
                                    ref={(el) => (inputrefs.current["trackInput"] = el)}
                                    onChange={(e) => setTrackValue(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            if (trackType === "awb") {
                                                fetchTracking("awb", trackValue);
                                            } else {
                                                fetchTracking("ref", trackValue);
                                            }
                                            inputrefs.current["btnSearch"]?.focus();
                                        }
                                    }}
                                    placeholder={(trackType === "awb" ? "Enter AWB No." : "Enter Reference No.")}
                            />
                                <button id="btnSearch" ref={(el) => (inputrefs.current["btnSearch"] = el)} className="search-btn" onClick={handleSearch}>
                                <i className="fa fa-arrow-right me-1"></i> Search
                            </button>
                        </div>
                        {loading ? (
                            <div className="tracking-loader-wrap">
                                <Loader />
                            </div>
                        ) : (
                            hasSearched &&
                            trackingData.length > 0 &&
                            trackingData.map((item, index) => (
                                <div key={index}>
                                    {/* CONSIGNMENT BAR */}
                                    <div className="cbar" id="cbar">
                                        <div className="cbar-item">
                                            <div className="cbar-label">AWB No.</div>
                                            <div className="cbar-value">{item?.awbNo}</div>
                                        </div>

                                        <div className="cbar-sep"></div>

                                        <div className="cbar-item">
                                            <div className="cbar-label">Booking Date</div>
                                            <div className="cbar-value">
                                                {item?.bookingDate}
                                            </div>
                                        </div>

                                        <div className="cbar-sep"></div>

                                        <div className="cbar-item">
                                            <div className="cbar-label">Current Status</div>
                                            <div className="cbar-value">
                                                <span className="">
                                                    <span className={`dot ${statusClass}`}></span> {item?.packetStatus}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="cbar-sep"></div>

                                        <div className="cbar-item">
                                            {item?.deliveredOn && (
                                                <>
                                                    <div className="cbar-label">Delivered On</div>
                                                    <div className="cbar-value">
                                                        {item?.deliveredOn || "-"}
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                        <div className="cbar-spacer"></div>
                                        {(item?.packetStatus?.toUpperCase() === "DELIVERED" && item?.pod === true) && (
                                            <button
                                                className="pod-btn"
                                                onClick={() => fetchPOD(item?.awbNo)}
                                                disabled={btnLoading}
                                            >
                                                {btnLoading ? (
                                                    <>
                                                        <i className="fa fa-spinner fa-spin"></i> Loading...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fa fa-file-image"></i> View POD
                                                    </>
                                                )}
                                            </button>
                                        )}
                                    </div>

                                    {/* MAIN GRID */}
                                    <div className="main-grid">
                                        {/* SHIPMENT DETAILS */}
                                        <div className="shipment-card">
                                            <div className="sc-header">
                                                <div className="sc-header-icon">
                                                    <i className="fa fa-cube"></i>
                                                </div>
                                                <div className="sc-header-title">Shipment Details</div>
                                            </div>

                                            <div className="sc-body">
                                                <div className="sc-field">
                                                    <div className="sc-field-label">
                                                        <i className="fa fa-hashtag"></i>
                                                        {trackType === "awb" ? " AWB No" : " Reference No"}
                                                    </div>

                                                    <div className="sc-field-value">
                                                        {trackType === "awb" ? item?.awbNo : item?.referenceNo}
                                                    </div>
                                                </div>

                                                <div className="row g-3">

                                                    <div className="col-6">
                                                        <p className="mb-0 text-muted" style={{ fontSize: "12px" }}>
                                                            <i className="fa fa-map-pin text-success me-2"></i>
                                                            Origin
                                                        </p>
                                                        <div className="sc-city fw-semibold">{item?.origin}</div>
                                                    </div>

                                                    <div className="col-6 ps-3">
                                                        <p className="mb-0 text-muted" style={{ fontSize: "12px" }}>
                                                            <i className="fa fa-map-marker-alt text-danger me-2"></i>
                                                            Destination
                                                        </p>
                                                        <div className="sc-city fw-semibold">{item?.destination}</div>
                                                    </div>

                                                </div>

                                                {item?.receiver && (
                                                    <>
                                                        <div className="col-12 d-flex align-items-start mt-3">
                                                            <div className="text-start">
                                                                <p className="mb-0 text-muted" style={{ fontSize: "12px" }}>
                                                                    <i className="fa fa-user text-danger me-2"></i>
                                                                    Receiver</p>
                                                                <div className="sc-city fw-semibold">{item?.receiver}</div>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                <hr className="sc-divider" />

                                                <div className="row g-3">
                                                    <div className="col-6 d-flex align-items-center">
                                                        <div>
                                                            <p className="mb-0 text-muted" style={{ fontSize: "12px" }}>
                                                                <i className="fa fa-layer-group text-success me-2"></i>
                                                                Pieces</p>
                                                            <div className="sc-city fw-semibold">{item?.peices}</div>
                                                        </div>
                                                    </div>

                                                    <div className="col-6 d-flex align-items-start ">
                                                        <div className="text-start">
                                                            <p className="mb-0 text-muted" style={{ fontSize: "12px" }}>
                                                                <i className="fa fa-truck text-danger me-2"></i>
                                                                Mode</p>
                                                            <div className="sc-city fw-semibold">{item?.mode}</div>
                                                        </div>
                                                    </div>


                                                </div>

                                                {item?.consignee && (
                                                    <div className="row g-3 mt-2">
                                                        <div className="col-6 d-flex align-items-center">
                                                            <label className="text-uppercase text-secondary fw-semibold me-2 mb-0" style={{ fontSize: "15px" }}>
                                                                Consignee :
                                                            </label>
                                                        </div>

                                                        <div className="col-6 d-flex align-items-start ">
                                                            <div className="fw-bold text-dark" style={{ fontSize: "15px" }}>
                                                                {item.consignee}
                                                            </div>
                                                        </div>


                                                    </div>
                                                )}

                                            
                                                <div className="row g-3 mt-2">

                                                    {item?.forwardingParty && (
                                                        <div className="col-md-6 align-items-center gap-2">
                                                            <div className="cbar-label">Forwarding Party</div>
                                                            <div className="cbar-value" style={{ fontSize: "12px" }}>
                                                                {item.forwardingParty || "-"}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {item?.forwardingNo && (
                                                        <div className="col-md-6 align-items-center gap-2">
                                                            <div className="cbar-label">Forwarding No</div>
                                                            <div className="cbar-value" style={{ fontSize: "12px" }}>
                                                                {item.forwardingNo || "-"}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {item?.forwardingUrl && (
                                                        <a href={item.forwardingUrl} target="_blank" className="ms-auto text-black font-semibold">
                                                            Tracking Line <ArrowRight size={15 } />
                                                        </a>
                                                    )}


                                                </div>

                                            </div>
                                        </div>

                                        {/* TRACKING DETAILS */}
                                        <div className="tracking-card">
                                            <div className="tc-header d-flex align-items-center">

                                                <div className="d-flex align-items-center gap-2">
                                                    <div className="tc-header-icon">
                                                        <Road />
                                                    </div>
                                                    <div className="tc-header-title">Tracking Details</div>
                                                </div>

                                            </div>
                                            {/* Progress */}
                                            <div className="container my-5">
                                                <div className="progress-wrapper">

                                                    <div className="progress-line-bg"></div>

                                                    <div
                                                        className="progress-line-active"
                                                        style={{
                                                            left: `${startOffset}%`,
                                                            width: `calc(${item?.lineWidth} * 0.75)`,
                                                            background:
                                                                item?.packetStatus === "DELIVERED"
                                                                    ? "linear-gradient(90deg, #10b981, #059669)"
                                                                    : "linear-gradient(90deg, #f59e0b, #d97706)"
                                                        }}
                                                    >
                                                    </div>

                                                    {/* Steps */}
                                                    <div className="d-flex justify-content-between steps-wrapper">
                                                        {item?.movesteps?.map((step, index) => {

                                                            let bgColor = "#fff";
                                                            let borderColor = "#d1d5db";
                                                            let textColor = "#6b7280";

                                                            if (step.packetStatus) {
                                                                switch (step.title.toUpperCase()) {
                                                                    case "BOOKED": bgColor = "#FFF9D2"; borderColor = "#facc15"; textColor = "#ca8a04"; break;
                                                                    case "INTRANSIT": bgColor = "#D2E9FF"; borderColor = "#3b82f6"; textColor = "#1d4ed8"; break;
                                                                    case "OFD": bgColor = "#FFE4D6"; borderColor = "#f97316"; textColor = "#ea580c"; break;
                                                                    case "RTO": bgColor = "#FFE4D6"; borderColor = "#f97316"; textColor = "#ea580c"; break;
                                                                    case "DELIVERED": bgColor = "#DCFCE7"; borderColor = "#22c55e"; textColor = "#16a34a"; break;
                                                                    default:
                                                                        break;
                                                                }
                                                            }

                                                            return (
                                                                <div key={index} className="text-center flex-fill">

                                                                    {/* Circle */}
                                                                    <div
                                                                        className={`rounded-circle d-flex align-items-center justify-content-center mx-auto
                                   ${step.isActive ? "completed-animate" : ""}`}
                                                                        style={{
                                                                            width: "54px",
                                                                            height: "54px",
                                                                            backgroundColor: bgColor,
                                                                            border: `2px solid ${borderColor}`,
                                                                            boxShadow: step.isActive
                                                                                ? "0 0 0 6px rgba(0,0,0,0.1)"
                                                                                : "none",
                                                                            transition: "all 0.3s ease"
                                                                        }}
                                                                    >
                                                                        <img src={step.imageURL} style={{ width: "24px" }} />
                                                                    </div>

                                                                    {/* Title */}
                                                                    <div
                                                                        className="mt-2 fw-semibold"
                                                                        style={{ color: textColor }}
                                                                    >
                                                                        {step.title}
                                                                    </div>

                                                                </div>
                                                            );
                                                        })}
                                                    </div>

                                                </div>
                                            </div>

                                            {/* Timeline */}
                                            <div className="timeline">
                                                {item?.shipping?.length > 0 ? (
                                                    [...item.shipping].map((item, index) => {
                                                        const text = item.tracking.toUpperCase();
                                                        let dotClass = "blue";
                                                        let textColor = "";
                                                        if (text.includes("DELIVER")) {
                                                            dotClass = "green";
                                                            textColor = "#22a96a";
                                                        } else if (text.includes("RECEIVED") || text.includes("FORWARDED")) {
                                                            dotClass = "orange";
                                                        }
                                                        return (
                                                            <div className="tl-event" key={index}>

                                                                <div className="tl-time">
                                                                    {item.date}
                                                                </div>
                                                                <div className="tl-status">
                                                                    <div className={`tl-dot ${dotClass}`}></div>
                                                                    <div
                                                                        className="tl-text"
                                                                        style={{ color: textColor }}
                                                                    >
                                                                        {text}
                                                                    </div>
                                                                </div>

                                                                {/* Location */}
                                                                {/*<div className="tl-loc">*/}
                                                                {/*    <i className="fa fa-location-dot"></i> {location}*/}
                                                                {/*</div>*/}

                                                            </div>
                                                        );
                                                    })
                                                ) : (
                                                    <div className="text-center">No Tracking Found</div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {index !== trackingData.length - 1 && (
                                        <hr className="tracking-divider" />
                                    )}

                                </div>
                            ))
                        )}

                    </div>

                    {showModal && (
                        <div
                            className="modal d-block"
                            tabIndex="-1"
                            style={{ background: "rgba(0,0,0,0.5)" }}
                        >
                            <div className="modal-dialog modal-dialog-centered modal-lg">
                                <div className="modal-content">

                                    {/* Header */}
                                    <div className="modal-header">
                                        <h5 className="modal-title">POD Preview</h5>

                                            <button
                                                type="button"
                                                className="btn btn-success btn-sm ms-3"
                                                onClick={handleDownloadPOD}
                                            >
                                                <i className="fa fa-download me-1"></i>
                                                Download POD
                                            </button>

                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => setShowModal(false)}
                                        ></button>
                                    </div>

                                    {/* Body */}
                                    <div className="modal-body text-center">

                                        {podImage ? (
                                            <img
                                                src={`data:image/jpeg;base64,${podImage}`}
                                                alt="POD"
                                                className="img-fluid rounded border"
                                                style={{ maxHeight: "75vh" }}
                                            />
                                        ) : (
                                            <p className="text-muted m-0">
                                                No POD Image Available
                                            </p>
                                        )}

                                    </div>

                                </div>
                            </div>
                        </div>
                    )}
                </section>
            )}
        </>
    )
}

export default Tracking;
